var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{attrs:{"id":"Welcome"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"only-screen"},[_c('span',[_vm._v("A great education in Victoria’s public school system begins at enrolment.")])])
}]

export { render, staticRenderFns }